// extracted by mini-css-extract-plugin
export default {"inputWrap":"Register_inputWrap__oX6Xt","tos":"Register_tos__+DUuR"};